import { Link } from 'react-router-dom';
import { FAQ } from '../content/site.js';

/**
 * Built on <details>/<summary> rather than a JavaScript accordion.
 *
 * It is keyboard-navigable and screen-reader-correct for free, it survives a
 * failed bundle, and — the reason that actually matters for a page like this —
 * browser find-in-page can search inside a closed <details>, which no custom
 * accordion manages.
 */
export default function Faq() {
  return (
    <>
      <section className="page-head">
        <div className="shell">
          <p className="eyebrow">Frequently asked questions</p>
          <h1>Questions, answered</h1>
          <p className="lede" style={{ marginTop: '1.2rem' }}>
            Straight answers about how we work, how we secure your environment, and what to
            expect when you partner with Ennoveda.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingTop: '2.5rem' }}>
        <div className="shell faq-shell">
          {FAQ.map((group) => (
            <div key={group.group} className="faq-group">
              <h2>{group.group}</h2>
              {group.items.map(([q, a]) => (
                <details key={q} className="faq-item">
                  <summary>{q}</summary>
                  <p className="dim">{a}</p>
                </details>
              ))}
            </div>
          ))}

          <div className="cta" style={{ marginTop: '3.5rem' }}>
            <h2>Still have questions?</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              Tell us what you are trying to solve and we will point you in the right direction.
            </p>
            <p style={{ marginTop: '1.8rem' }}>
              <Link to="/contact" className="btn btn-primary">Contact us</Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
